import * as Sentry from "@sentry/react";

const release = import.meta.env.PACKAGE_NAME + "@" + import.meta.env.PACKAGE_VERSION;

import { appConfig } from "~/src/appConfig";

if (!["development"].includes(appConfig.environment)) {
  Sentry.init({
    dsn: "https://d489e873009ce32eff2f7388f5dcec76@o4508364397936640.ingest.de.sentry.io/4510045777363024",
    integrations: [Sentry.browserTracingIntegration()], //, Sentry.replayIntegration()],
    tracesSampleRate: 0.25,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    release: release,
    environment: appConfig.environment,
    beforeSend: (event) => {
      if (window.location.hostname === "localhost") {
        return null;
      }
      if (event.exception?.values?.[0]?.type === "TypeError") {
        return null; // Ignore specific error types
      }
      return event;
    },
  });
  console.log("Sentry initialized: ", release, "/", appConfig.environment);
} else {
  console.log("Sentry disabled: ", release, "/", appConfig.environment);
}
export const sentryLogError = (error: Error) => {
  Sentry.captureException(error);
  console.error(error);
};
